/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1212__part-0
 */

"use strict"

import { a } from "./index__part-1"
import { h } from "./index__part-2"
var r = {}
Object.defineProperty(r, "FunctionToString", {
  get: function () {
    return a
  }
})
Object.defineProperty(r, "InboundFilters", {
  get: function () {
    return h
  }
})
export { r }
